/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import type { DocSearchTranslations } from '@docsearch/react';

const useTranslations = (): DocSearchTranslations & { placeholder: string } => {
  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);

  return {
    button: {
      buttonText: clientI18n('search.SearchBar.label'),
      buttonAriaLabel: clientI18n('search.SearchBar.label'),
    },
    modal: {
      searchBox: {
        resetButtonTitle: clientI18n('search.SearchModal.searchBox.resetButtonTitle'),
        resetButtonAriaLabel: clientI18n('search.SearchModal.searchBox.resetButtonTitle'),
        cancelButtonText: clientI18n('search.SearchModal.searchBox.cancelButtonText'),
        cancelButtonAriaLabel: clientI18n('search.SearchModal.searchBox.cancelButtonText'),
      },
      startScreen: {
        recentSearchesTitle: clientI18n('search.SearchModal.startScreen.recentSearchesTitle'),
        noRecentSearchesText: clientI18n('search.SearchModal.startScreen.noRecentSearchesText'),
        saveRecentSearchButtonTitle: clientI18n(
          'search.SearchModal.startScreen.saveRecentSearchButtonTitle',
        ),
        removeRecentSearchButtonTitle: clientI18n(
          'search.SearchModal.startScreen.removeRecentSearchButtonTitle',
        ),
        favoriteSearchesTitle: clientI18n('search.SearchModal.startScreen.favoriteSearchesTitle'),
        removeFavoriteSearchButtonTitle: clientI18n(
          'search.SearchModal.startScreen.removeFavoriteSearchButtonTitle',
        ),
      },
      errorScreen: {
        titleText: clientI18n('search.SearchModal.errorScreen.titleText'),
        helpText: clientI18n('search.SearchModal.errorScreen.helpText'),
      },
      footer: {
        selectText: clientI18n('search.SearchModal.footer.selectText'),
        selectKeyAriaLabel: clientI18n('search.SearchModal.footer.selectKeyAriaLabel'),
        navigateText: clientI18n('search.SearchModal.footer.navigateText'),
        navigateUpKeyAriaLabel: clientI18n('search.SearchModal.footer.navigateUpKeyAriaLabel'),
        navigateDownKeyAriaLabel: clientI18n('search.SearchModal.footer.navigateDownKeyAriaLabel'),
        closeText: clientI18n('search.SearchModal.footer.closeText'),
        closeKeyAriaLabel: clientI18n('search.SearchModal.footer.closeKeyAriaLabel'),
        searchByText: clientI18n('search.SearchModal.footer.searchByText'),
      },
      noResultsScreen: {
        noResultsText: clientI18n('search.SearchModal.noResultsScreen.noResultsText'),
        suggestedQueryText: clientI18n('search.SearchModal.noResultsScreen.suggestedQueryText'),
        reportMissingResultsText: clientI18n(
          'search.SearchModal.noResultsScreen.reportMissingResultsText',
        ),
        reportMissingResultsLinkText: clientI18n(
          'search.SearchModal.noResultsScreen.reportMissingResultsLinkText',
        ),
      },
    },
    placeholder: clientI18n('search.SearchModal.placeholder'),
  };
};

export default useTranslations;
